import React, { useContext, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import { AuthContext } from "shared/context/auth-context";
import { getTodayInTimezone } from "shared/utility/date";
import { isRideSkipUiEnabled } from "./constants";
import { useRideSkipApi } from "./useRideSkipApi";

const studentIdOf = (student) => String(student?.id || student?._id || "");

const RideSkipLivePanel = ({ serviceKind, serviceId, students }) => {
  const { t } = useTranslation();
  const auth = useContext(AuthContext);
  const enabled = isRideSkipUiEnabled(auth?.company);
  const { listForService } = useRideSkipApi();
  const today = getTodayInTimezone(auth?.company?.timezone || auth?.timezone, "yyyy-MM-dd");
  const [skips, setSkips] = useState([]);

  useEffect(() => {
    if (!enabled || !serviceId) return undefined;
    let cancelled = false;
    const tick = async () => {
      const data = await listForService({ serviceKind, serviceId, day: today });
      if (!cancelled) setSkips(Array.isArray(data?.skips) ? data.skips : []);
    };
    tick();
    const interval = setInterval(tick, 15000);
    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, [enabled, serviceId, serviceKind, today, listForService]);

  const names = useMemo(() => {
    const roster = Array.isArray(students) ? students : [];
    const byId = new Map(roster.map((s) => [studentIdOf(s), s?.name || s?.fullname || ""]));
    return skips.map((row) => byId.get(String(row.studentId)) || t("rideSkip.unknownStudent"));
  }, [skips, students, t]);

  if (!enabled || !serviceId || names.length === 0) return null;

  return (
    <div className="qr-attendance-container" style={{ marginBottom: 12 }}>
      <div className="qr-attendance-header">
        <h4>{t("rideSkip.liveTitle")}</h4>
        <div className="qr-attendance-summary">{t("rideSkip.count", { count: names.length })}</div>
      </div>
      {names.map((name, index) => (
        <div key={`${name}-${index}`} className="qr-attendance-item">
          <span className="qr-attendance-item-name">{name}</span>
          <span className="qr-attendance-item-time">{t("rideSkip.willSkip")}</span>
        </div>
      ))}
    </div>
  );
};

export default RideSkipLivePanel;
